export function debounce<T extends unknown[]>(func: (...args: T) => any, ms: number) {
    let timeout: number | null = null;
    return (...value: T) => {
        if (timeout) {
            self.clearTimeout(timeout);
            timeout = null;
        }
        timeout = self.setTimeout(() => {
            timeout = null;
            func(...value);
        }, ms);
    };
}

export function debounceFunction(ms: number) {
    return debounce<[() => void]>((func) => {
        func();
    }, ms);
}
